__turbopack_context__.v({
  "attentionIcon": "styles-module__rpbkMW__attentionIcon",
  "errorContainer": "styles-module__rpbkMW__errorContainer",
  "errorText": "styles-module__rpbkMW__errorText",
  "optionsContainer": "styles-module__rpbkMW__optionsContainer",
  "optionsGrid": "styles-module__rpbkMW__optionsGrid",
  "standardAspect": "styles-module__rpbkMW__standardAspect",
  "title": "styles-module__rpbkMW__title",
  "wideAspect": "styles-module__rpbkMW__wideAspect",
});
